import { tw } from '@/common';
import { mepPlanActivationLevels, MepLevelInfoCardBanner } from '@/features';

export const mepWarningLevelBanner: Record<(typeof mepPlanActivationLevels)[number], MepLevelInfoCardBanner> = {
  advice: {
    text: 'Advice',
    backgroundColor: tw`bg-[#FBE032]`,
  },
  'watch-and-act': {
    text: 'Watch and Act',
    backgroundColor: tw`bg-[#FF7900]`,
  },
  'emergency-warning': {
    text: 'Emergency Warning',
    backgroundColor: tw`bg-[#D6001C]`,
    textColor: tw`text-white`,
  },
};
